import React from "react";

export default function ApplyLeave() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Apply Leave</h1>
      <p>Use this page to apply for leave and view your leave history.</p>

      {/* Example form */}
      <form className="mt-4 space-y-4 max-w-md">
        <div>
          <label className="block mb-1">Leave Type</label>
          <select className="w-full p-2 border rounded">
            <option>Casual Leave</option>
            <option>Sick Leave</option>
            <option>Paid Leave</option>
          </select>
        </div>
        <div>
          <label className="block mb-1">Start Date</label>
          <input type="date" className="w-full p-2 border rounded" />
        </div>
        <div>
          <label className="block mb-1">End Date</label>
          <input type="date" className="w-full p-2 border rounded" />
        </div>
        <div>
          <label className="block mb-1">Reason</label>
          <textarea className="w-full p-2 border rounded" rows="3"></textarea>
        </div>
        <button type="submit" className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700">Submit</button>
      </form>
    </div>
  );
}
